export const BackArrow = () => {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1657 7.76252C10.8726 7.77345 10.597 7.90033 10.3957 8.11252L4.8657 13.7125L4.0957 14.5L4.8657 15.2875L10.3957 20.8875C10.831 21.3316 11.5441 21.3403 11.9882 20.905C12.4323 20.4697 12.441 19.7566 12.0057 19.3125L8.3482 15.62H22.4007C22.8054 15.6266 23.1795 15.4144 23.3829 15.0644C23.5885 14.7166 23.5885 14.2835 23.3829 13.9356C23.1795 13.5856 22.8054 13.3735 22.4007 13.38H8.3482L12.0057 9.68752C12.3426 9.36158 12.4432 8.86283 12.2551 8.43189C12.067 8.00314 11.6338 7.73626 11.1657 7.76252Z"
        fill="#000113"
      />
    </svg>
  );
};
